import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from '../../utils/experience/main.tsx';
import type { JPDExperience } from '../../utils/experience/types.tsx';

export const changeViewName: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.nav-bar.change-view-name', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const changeViewRank = createJpdExperience(
	new UFOExperience('jpd.nav-bar.change-view-rank', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const createView = createJpdExperience(
	new UFOExperience('jpd.nav-bar.create-view', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
